import api from '../api/axios.config';

export const supplyChainService = {
  getFilterOptions: async() => {
    try{
      const params = { };

      const response = await api.get(`/supply-chain/filter-options`, { params });
  
      return response.data;
    }catch(error){
      throw error
    }
  },

  getData: async(category, source, page, page_size, columnFilters = {}) => {
    try{
      const params = { };

      if (category) params.category = category;
      if (source) params.source = source;
      if (page) params.page = page;
      if (page_size) params.page_size = page_size;

      Object.entries(columnFilters).forEach(([key, values]) => {
        if (values?.length) params[key] = values;
      });

      const response = await api.get(`/supply-chain`, { params });

      return response.data;
    }catch(error){
      throw error
    }
  },

  getInfoIcons: async() => {
    try{
      const params = { };

      const response = await api.get(`/supply-chain/information-icons`, { params });
  
      return response.data;
    }catch(error){
      throw error
    }
  },

  getSummary: async(category, source, view_type) => {
    try{
      const params = { };
  
      if (category) params.category = category;
      if (source) params.source = source;
      if (view_type) params.view_type = view_type;

      const response = await api.get(`/supply-chain/summary`, { params });
  
      return response.data;
    }catch(error){
      throw error
    }
  },

  downloadExcel: async(period, category, source) => {
    try{
      const params = { };
  
      if (period) params.period = period;
      if (category) params.category = category;
      if (source) params.source = source;

      const response = await api.get(`/supply-chain/download`, 
        { 
          params,
          responseType: "blob",
        });
  
      return response;
    }catch(error){
      throw error
    }
  },

  updateAdjustedQty: async (period, sku_code, adjusted_quantity_in_mc) => {
    try{
      const response = await api.patch(
          `/supply-chain?period=${period}`,
          {
            updates: [
              {
                sku_code,
                adjusted_quantity_in_mc,
              },
            ],
          },
      );
  
      return response.data;
    }
    catch(error){
      throw error
    }
  },
};
